/** Panel stack: bottom sheet in portrait, side sheet in landscape (CSS handles it). */
import { useEffect } from 'preact/hooks';
import { useStore } from '../store';
import { TipCard } from './TipCard';

export function Sheet({ onClose, children, label, hero }: { onClose(): void; children: preact.ComponentChildren; label: string; hero?: boolean }) {
  const { noteSheet } = useStore();
  useEffect(() => {
    noteSheet(true);
    return () => { noteSheet(false); };
  }, [noteSheet]);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('keydown', onKey); };
  }, [onClose]);
  return (
    <>
      {/* Real <button>: div backdrops are unreliable tap targets on iOS. */}
      <button type="button" class="panel-backdrop" aria-label="Close panel" onClick={onClose} />
      <section class={hero ? 'sheet sheet-hero' : 'sheet'} aria-label={label}>
        {!hero && <div class="sheet-controls"><div class="sheet-grab" /></div>}
        <button type="button" class="sheet-close" aria-label={`Close ${label}`} onClick={onClose}>x</button>
        <div class="sheet-body">{!hero ? <TipCard inSheet /> : null}{children}</div>
      </section>
    </>
  );
}
